import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FooterNotificationPictoProps extends pictoProps {
}

export interface FooterNotificationPictoState extends pictoState {
}

export class FooterNotificationPicto extends Picto<FooterNotificationPictoProps,FooterNotificationPictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.footerNotificationPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FooterNotificationPicto);
